exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc .pc-order-history .pc-content-header {\n  margin-bottom: 15px;\n}\n\n", ""]);

// exports
